import { MODULE } from "./page-filter.actionTypes";

export const getFilter = (state) => state.getIn([MODULE, "filter"]);

// export const getFormattedFilter = (state) => {
//   const filter = getFilter(state);
//   return filter ? Object.fromEntries(filter.map(({ id, values }) => [id, values])) : {};
// };

export default {};
